<template>
  <div
    class="tab-item-wrapper"
    :class="{ 'active': isSelected }"
    @click="$emit('onClick')"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'tab',

  props: {
    label: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .tab-item-wrapper {
    font-size: 16px;
    color: #808080;
    padding: 10px 0 10px 0;
    cursor: pointer;

    @media (min-width: 576px) {
      margin: 0 20px 0 0;
      padding: 4px 0 4px 0;
    }

    @media (max-width: 576px) {
      width: 100%;
      text-align: center;
    }

    &.active {
      color: #9013fe;
      border-bottom: 2px solid #9013fe;
    }
  }
</style>
